// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.bordetitulo {
  height: 1px;
  width: 100%;
  background-color: #450d1c;
}

.badge {
  font-size: 0.65rem;
  color: #333;
  font-weight: 600;
  padding: 0.3rem 0.6rem;
  margin-right: 10px;
}

.badge-light {
  background-color: #e5e5e5;
}

.flex-cols__folding .accordion.width .card-body__trigger {
  top: 0px;
  margin-right: 0px;
}

.flex-cols__folding .accordion.width .card-body__trigger::before {
  left: -1.45rem !important;
  padding: 0.1rem 0 !important;
  height: 20px !important;
}

@media (min-width: 500px) {
  .flex-cols__folding .accordion.width .card-header {
    left: 7px;
    top: 5px;
  }
}
.flex-cols__folding .accordion.width .card-header__trigger::before {
  left: 0px !important;
}

.some-custom-class-name::ng-deep {
  border-collapse: collapse !important;
  border-spacing: 2px !important;
}

.some-custom-class-name::ng-deep tr {
  font-size: 0.8rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #212529 !important;
  text-align: left !important;
}

.some-custom-class-name::ng-deep th {
  vertical-align: bottom !important;
  padding: 0.75rem !important;
  border-bottom: 2px solid #dee2e6 !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  text-align: inherit !important;
  background-color: #fff !important;
  font-family: "Open sans", sans-serif !important;
  max-width: 250px;
}

.some-custom-class-name::ng-deep td {
  padding: 0.75rem 0.75rem 0 0.75rem !important;
  vertical-align: top !important;
  border-top: 1px solid #dee2e6 !important;
  border-left: none !important;
  border-right: none !important;
  background-color: #fff !important;
  color: #333 !important;
  font-size: 0.8rem !important;
  max-width: 250px;
}

body .p-tabview.p-tabview-top .p-tabview-nav li.p-state-active,
body .p-paginator .p-paginator-pages .p-paginator-page.p-state-active,
body .p-datatable .p-sortable-column.p-state-highlight {
  background-color: #e5e5e5 !important;
  border: 1px solid rgb(117, 38, 65) !important;
}

.btn-success {
  background-color: #73D313;
  color: #fff;
  border-radius: 8px;
  border-color: #73D313;
  transition: all 0.3s ease-in;
  min-height: inherit;
  padding: 0.025rem 0 0 0.15rem;
  width: 1.5rem;
  height: 1.5rem;
}

.btn-success img {
  width: 70%;
  height: 70%;
  font-size: small;
  margin-bottom: 5px;
  margin-right: 2px;
}

.btn-success:active, .btn-success:focus, .btn-success:hover {
  background-color: #62B113 !important;
  border-color: #62B113 !important;
  transition: all 0.3s ease-in;
  color: #fff !important;
}

#mesageAlert {
  color: #a94442;
  font-size: calc(14px + 2 * (100vw - 320px) / 1600);
  line-height: 1.5em;
}

.clickable:hover {
  cursor: pointer;
  cursor: hand;
}

.form-group--noborder {
  padding-top: 0;
  min-height: inherit;
  padding: 0.8rem 0 0 0.5rem;
  color: #333;
}

.form-group--noborder label {
  color: #666;
  font-size: 0.875rem;
  line-height: 1.5em;
  margin-bottom: 0px;
  text-decoration: none;
}

.form-control:focus {
  outline: none !important;
  border-color: #450d1c !important;
  box-shadow: 0 0 6px #450d1c !important;
}

td p, .recorteCab {
  word-wrap: break-word !important;
  text-overflow: ellipsis !important;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
}

td a p {
  color: #6E374B;
}

td a p:hover, td a:hover {
  color: #BE1111;
  transition: all 0.3s ease-in;
}

.nolinea {
  text-decoration: none !important;
  color: #000000;
}

#titleWS {
  font-family: "Open sans", sans-serif;
}

.editoricon {
  width: 16px;
  height: 16px;
  line-height: 3px !important;
  bottom: 2px;
}

.editorbutton {
  width: 16px;
  height: 16px;
  line-height: 5px;
  margin-top: 8px;
  margin-right: 5px;
}

#cabTabla {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}

#container-component {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.container {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.flex-cols__contain {
  margin: 1rem 0 0 0.5rem !important;
  padding-bottom: 0px !important;
  overflow-x: hidden !important;
}

.formalities-box__item {
  margin-bottom: 0 !important;
}

.formalities-box__consult {
  margin-top: 1rem !important;
}

.container {
  max-width: 95% !important;
}

.flex-cols {
  margin-top: 0px;
}

.flex-cols__sidebar-item {
  margin-top: 5px;
}

.flex-cols__valoration {
  padding: 0.75rem !important;
  width: 98% !important;
  margin-top: 10px;
}

.recilabel {
  margin-top: 5px;
}

.nav-link[data-toggle].collapsed:after {
  content: " ▾";
  color: #666;
}

.nav-link[data-toggle]:not(.collapsed):after {
  content: " ▴";
  color: #666;
}

#link-carousel {
  color: black;
  text-decoration: none;
}

#titol-carousel {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 6px;
  color: #450d1c;
}

#item-carousel {
  padding: 6px;
}

.tramit-item .tramit-item-content {
  border: 1px solid var(--surface-d);
  border-radius: 3px;
  margin: 0.3rem;
  text-align: center;
  padding: 2rem 0;
}
.tramit-item .tramit-image {
  width: 50%;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.notificaBox {
  margin: 0.3rem;
  padding: 2rem 0;
}

/*#expedMargin{
    margin-left: 0px;
}*/
.contPrincDatosGener {
  padding-bottom: 0px !important;
}

.contSecunDatosGener {
  margin-right: 0px !important;
  margin-top: 1.5rem !important;
}

.btn-warning {
  font-size: calc(14px + 2 * (100vw - 320px) / 1600);
  font-weight: 600;
  min-height: 40px;
  background-color: #FFA429;
  -webkit-box-align: center;
  transition: all 0.3s ease-in;
  border-radius: 8px;
  border-color: #FFA429;
  transition: all 0.3s ease-in;
  color: #fff;
  align-items: center;
  justify-content: center;
  min-width: 100%;
  margin-top: 0px !important;
}

.btn-warning:active, .btn-warning:focus, .btn-warning:hover {
  background-color: #E66819 !important;
  border-color: #E66819 !important;
  transition: all 0.3s ease-in;
  color: #fff !important;
}

.p-datatable-scrollable-header-box {
  padding-right: 0px !important;
}

.deskoptr:hover {
  cursor: zoom-in;
}

.textDerecha {
  width: 110px;
  text-align: right;
}

.textDerechaFac {
  width: 120px;
  text-align: right;
}

.notification-box__item {
  justify-content: normal;
}

#tercer_select {
  font-size: 0.8rem;
  min-height: 0px;
  padding: 0px;
  background: url('arrow_down.3e717c92f816c5bb.svg') 99% center no-repeat;
  cursor: pointer;
}

@media (max-width: 500px) {
  #tercer_form {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  #collapseOne {
    display: none;
  }
  .flex-cols__folding .accordion.width .card-header {
    margin-left: 5px;
  }
  .flex-cols__folding .accordion.width .card .width {
    margin-left: 5px;
  }
  .divcombotercer {
    margin-top: -15px;
  }
  .labelmovil {
    font-size: 0;
  }
  .experespon {
    text-align: left !important;
  }
  .textDerecha {
    width: 95px;
  }
  .textDerechaFac {
    width: 110px;
  }
  .linkrebut {
    max-width: 100px;
  }
  .butonrefres {
    display: inline-flex;
    border-style: groove;
    border-radius: 5px;
  }
  .marginRefre {
    margin-top: 2.5px;
  }
  .centrado {
    text-align: center;
  }
  .divtable {
    overflow-x: scroll;
  }
  .padronlabel {
    border-bottom: 1px solid var(--surface-d);
    border-right: none !important;
  }
  .avisosflex {
    display: block !important;
  }
  .searchTramit {
    max-width: 85%;
    flex: auto;
  }
  .divmenu {
    padding-right: 0px !important;
  }
  .mensajecheck {
    font-size: 0.675rem;
    padding-bottom: 5px;
  }
  .butonRefreMV {
    display: block !important;
    min-width: 35%;
  }
  .butonRefrePC {
    display: none !important;
  }
  .alingCabTit {
    min-width: 65%;
  }
  .noborder {
    border-radius: 0px !important;
  }
  .margenBusca {
    margin-bottom: 0.5rem !important;
  }
  .botontable {
    font-size: 0px;
    padding-top: 10px;
  }
  .foldersize {
    height: 24px !important;
    width: 24px !important;
  }
  /*.buscadorTramit{
      width: 100% !important;
      margin-right: 15px;
  }*/
}
.btnrefres {
  width: 150px !important;
}

.linkEstilo, .linkrebut {
  color: rgb(110, 55, 75);
  transition: all 0.3s ease-in 0s;
}

.linkEstilo:hover, .linkrebut:hover {
  color: rgb(190, 17, 17);
  transition: all 0.3s ease-in 0s;
}

#tercer_form {
  border: none;
  margin: 0px;
  min-height: 0px;
}

.padronlabel {
  border-right: 1px solid var(--surface-d);
}

.divusuario {
  border: 1px solid #e6e6e6;
  background-color: #f6f4f5;
}

.avisosflex {
  display: flex;
}

/*.iconomobil { margin-left: 10px; }

.notibusca {
    padding-bottom: 2px;
    background-color: #FFA429;
}*/
.buscamenu {
  border-radius: 0px;
}

.estilobusca {
  background-color: #FFA429;
  color: #fff;
}

.nav-tabs .nav-link.active, .nav-tabs--min .nav-link.active {
  border-color: #FFA429 !important;
  color: #FFA429 !important;
}

.nav-tabs .nav-link, .nav-tabs--min .nav-link {
  border: 0 !important;
  border-bottom: 2px solid #ccc !important;
}

a#all-tab::after, a#citizens-tab::after {
  content: "" !important;
}

.bordeTramit {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-color: #ccc;
}

.nav-tabs {
  border-bottom: none;
}

.btn-outline-dark:hover {
  border-color: #FFA429;
  transition: all 0.3s ease-in;
  background-color: #fff;
  color: #333;
}

.btn-outline-dark {
  border: 2px solid #333;
  transition: all 0.3s ease-in;
  border-radius: 6px;
  background-color: #fff;
  font-weight: 600;
  color: #333;
}

#tramitsbusqueda {
  height: auto;
}

.mensajecheck {
  text-align: left;
}

.butonRefrePC {
  display: block;
}

.butonRefreMV {
  display: none;
}

.margenBusca {
  margin-bottom: 0.25rem;
}

.foldersize {
  height: 18px;
  width: 20px;
}

.overinherit {
  overflow: inherit !important;
}

.foldersizequeixes {
  width: 15px;
  padding-top: 3px;
}

#imagenIcono {
  width: 1.5rem;
  height: 1.5rem;
}

.colornegro {
  color: #000000;
}

.colorgris {
  color: #666;
}

/*.buscadorTramit{
    width: 30%;
}*/
/*.banner-splash__contain {
    margin-left: 50%;
}

.banner-splash{
    background-color: transparent;
}

.banner-splash__info{
    position: inherit;
    width: 100%;
    right: 0px;
    top: 0px;
}*/`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
